const validateFile = (allowedTypes: string[], maxSizeInBytes?: number, errorMessage?: string) => {
    return (file: File) => {
        if (!allowedTypes.includes(file.type)) {
            alert(errorMessage ?? `File type ${file.type} is not allowed.`);
            return false;
        }
        if (maxSizeInBytes && file.size > maxSizeInBytes) {
            alert(`File size exceeds the maximum allowed size of ${maxSizeInBytes} bytes.`);
            return false;
        }
        return true;
    };
};

const EMPTY_OBJECT: Record<string, any> = {};

const toObject = (value: unknown): Record<string, any> => {
    if (!value) return EMPTY_OBJECT;
    if (typeof value === 'object') return value as Record<string, any>;
    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            return typeof parsed === 'object' && parsed !== null ? (parsed as Record<string, any>) : EMPTY_OBJECT;
        } catch {
            return EMPTY_OBJECT;
        }
    }
    return EMPTY_OBJECT;
};

const deepClone = <T,>(value: T): T => JSON.parse(JSON.stringify(value));

export { validateFile, EMPTY_OBJECT, toObject, deepClone };